import { Box } from '@mui/material'
import { ButtonIconSeeker } from '@ui-seeker/core'
import React from 'react'
import { dsColorNew } from '@palette'

export default function exportUrlColumn() {

	return [ {
		name: 'exportUrl',
		label: 'Export URL',
		options: {
			filterType: 'textField',
			display: 'excluded',
			customBodyRowRender: value => value,
		},
	}, {
		name: 'exportUrl',
		label: 'Export URL',
		options: {
			filter: false,
			customBodyRowRenderLite: (value) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<ButtonIconSeeker
						icon="link"
						iconProps={{ sx: { color: dsColorNew.appBlue } }}
						onClick={e => {
							window.open(value, '_blank')
							if (e.ctrlKey) e.preventDefault()
						}}
						tooltip="Open in new tab"
					/>
				</Box>
			),
		},
	} ]
}
